module.exports = __webpack_public_path__ + "img/badge_color_ihe-finance.a5d855ce.svg";